// Copyright (c) 2016 Deere & Company

import Dealer, {getDefaultState as getDealerDefaultState} from './dealer';
import TimestampUser, {getDefaultState as getTimestampUserDefaultState} from './timestamp-user';
import TransferProduct, {getDefaultState as getTransferProductDefaultState} from './transfer-product';
import t from 'tcomb';

const Transfer = t.struct({
    approverComment: t.maybe(t.String),
    currentDealer: Dealer,
    id: t.String,
    newDealer: Dealer,
    product: TransferProduct,
    reasonForChange: t.String,
    requestDate: t.Number,
    requestedBy: TimestampUser,
    status: t.String
}, {
    name: 'Transfer',
    strict: true
});

export const getDefaultState = () => new Transfer({
    currentDealer: getDealerDefaultState(),
    id: '',
    newDealer: getDealerDefaultState(),
    product: getTransferProductDefaultState(),
    reasonForChange: '',
    requestDate: 0,
    requestedBy: getTimestampUserDefaultState(),
    status: ''
});

export default Transfer;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/transfer.js